import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { InputGroup } from 'react-bootstrap';

import { useState, useEffect } from 'react';
import IngredientDisplay from './IngredientDisplay';
import { Modal } from 'react-bootstrap';

import api_url from '../../config/api_url';
import { authHeaders } from '../../utils/authHeaders';


const IngridientList = () => {

    const [ingredients, setIngredients] = useState([{name: ""}]);
    const [param, setParam] = useState("");
    const [show, setShow] = useState(false);
    const [currentIdx, setCurrentIdx] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    useEffect(() => {
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          

          const fetchUrl = api_url + "/api/ingredients" + (param.length>0? "/" + param : "");
          const data = await fetch(fetchUrl);
          const json = await data.json();
          console.log(json);

          //const data = [{name: "abc", id: 1, price:"12dkk",}, {name: "efg", id: 2, price:"12dkk"}, {name:param, id: 3, price:"14dkk"} ]
          // convert the data to json
          //const json = await response.json();
        
          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setIngredients(json);
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [param])


    const removeHandler = (idx) => {
        handleShow();
        setCurrentIdx(idx);
    }

    const editHandler = async (idx, obj) => {
        if(obj.id !== undefined) {
            const response = await fetch(api_url + '/api/ingredients', {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({ingredient: obj})
              });

        } else {

            const response = await fetch(api_url + '/api/ingredients', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({ingredient: obj})
              });
              let json = await response.json();
              obj = json;
        }
        

        setIngredients([
            ...ingredients.slice(0, idx),
            obj,
            ...ingredients.slice(idx +1 )
        ]);


    }

    const deleteIngredient = async () => {
        handleClose();

        const response = await fetch(api_url + '/api/ingredients', {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authHeaders()
            },
            body: JSON.stringify({id: ingredients[currentIdx].id})
          });

        


        setIngredients([
            ...ingredients.slice(0, currentIdx),
            ...ingredients.slice(currentIdx + 1)
          ]);
    }

    const addNewIngredient = () => {
        setIngredients([...ingredients, {name:""}])
    }


    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Slet Ingrediens</Modal.Title>
                </Modal.Header>
                <Modal.Body>Er du sikker på du vil slette ingrediensen {ingredients.length > 0 ? ingredients[currentIdx].name : "ERROR"}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Tilbage
                    </Button>
                    <Button variant="primary" onClick={deleteIngredient}>
                        Slet
                    </Button>
                </Modal.Footer>
            </Modal>

        <Row className="justify-content-center">
            <Col xs={10}>
            <Form.Control
            placeholder="Ingredienser"
            aria-label="Ingredients"
            aria-describedby="pinMapButton"
            value={param || ""}
            onChange={e => setParam(e.target.value)}
            onBlur={e => setParam(e.target.value)}
            />
            </Col>
        <Row>
            <Col xs={10}>
                <Button onClick={addNewIngredient}>Tilføj en ny ingrediens</Button>
            </Col>
        </Row>
        </Row>
            {ingredients.length > 0 ? ingredients.map((ingredient, i) => <IngredientDisplay obj={ingredient} key={i} index={i} deleteFunction={removeHandler} editFunction={editHandler} />) : null}
        </>
        
    );

}

export default IngridientList;